import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { CSSTransition } from 'react-transition-group';

import { useTranslation } from '@gem/modules/i18n';

import { useWaitingAudioOpponentsToastPresenter } from './WaitingAudioOpponentsToast.presenter';
import styles from './WaitingAudioOpponentsToast.styles.m.css';

const ANIMATION_TIMEOUT = 250;

const itemTransition = {
  enter: styles.enter,
  enterActive: styles.enterActive,
  exit: styles.exit,
  exitActive: styles.exitActive,
};

export const WaitingAudioOpponentsToast: FC = observer(() => {
  const { t } = useTranslation();
  const presenter = useWaitingAudioOpponentsToastPresenter();

  return (
    <CSSTransition
      in={presenter.isToastShown}
      classNames={itemTransition}
      timeout={ANIMATION_TIMEOUT}
      mountOnEnter
      unmountOnExit
    >
      <div className={styles.event}>
        <div className={styles.eventText}>
          {t(
            presenter.canStartAudio
              ? 'calls_call_to_turn_on_sound_message'
              : 'calls_waiting_for_participants_message'
          )}
        </div>
        {presenter.canStartAudio ? (
          <button
            className={styles.eventButton}
            onClick={presenter.onPlayAudioClick}
          >
            {t('common_ok')}
          </button>
        ) : null}
      </div>
    </CSSTransition>
  );
});
